import type { Mission } from '../missions.ts'

export const dol: Mission = {
  id: "dol",
  name: "U.S. Department of Labor",
  short: "DOL",
  call: "Labor",
  kind: "department",
  url: "https://www.dol.gov/",
  established: 1913,
  palette: {
    primary: "#0071bc",
    secondary: "#053a82",
    accent: "#fda65e",
  },
  colorSource: {
    kind: "site",
    url: "https://www.dol.gov/",
  },
  motif: "anvil",
  mission: {
    text: "To foster, promote, and develop the welfare of the wage earners, job seekers, and retirees of the United States; improve working conditions; advance opportunities for profitable employment; and assure work-related benefits and rights.",
    url: "https://www.dol.gov/general/aboutdol",
  },
  fact: {
    text: "President Taft signed the bill creating the Department of Labor on March 4, 1913, hours before Woodrow Wilson took office.",
    url: "https://www.dol.gov/general/aboutdol/history/dolchp01",
  },
  seal: {
    file: "public/seals/dol.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_Labor.svg",
  },
  identifier: {
    about: "https://www.dol.gov/general/aboutdol",
    accessibility: "https://www.dol.gov/general/aboutdol/accessibility",
    foia: "https://www.dol.gov/general/foia",
    noFear: "https://www.dol.gov/agencies/oasam/centers-offices/civil-rights-center/resports/notification-and-federal-employee-antidiscrimination-retaliation-act-of-2002",
    oig: "https://www.oig.dol.gov/",
    performance: "https://www.dol.gov/general/aboutdol#budget",
    privacy: "https://www.dol.gov/general/privacynotice",
  },
  media: {
    photos: [
      {
        file: "/media/dol-perkins-building.jpg",
        small: "/media/dol-perkins-building-sm.jpg",
        alt: "The long concrete facade of the Frances Perkins Building, with rows of windows above a landscaped terrace and stairs.",
        title: "Frances Perkins Building, Department of Labor headquarters, Washington, D.C.",
        creator: "U.S. Department of Labor",
        source: "https://commons.wikimedia.org/wiki/File:Frances_Perkins_Building_of_the_United_States_Department_of_Labor_in_Washington,_D.C._-_1.jpg",
        license: "CC BY 2.0",
      },
      {
        file: "/media/dol-perkins-sign.jpg",
        small: "/media/dol-perkins-sign-sm.jpg",
        alt: "A dark Frances Perkins Building sign bearing the Department of Labor seal, lit at dusk beside a glowing lamp and the building's facade.",
        title: "Frances Perkins Building entrance sign, Washington, D.C.",
        creator: "U.S. Department of Labor",
        source: "https://commons.wikimedia.org/wiki/File:Frances_Perkins_Building_(30602084122).jpg",
        license: "CC BY 2.0",
      },
    ],
  },
}
